export const BASE_URL = "https://api.pinnako.io";
